import { styled } from '@mui/material/styles';

export const DrawerContent = styled('div', {
  slot: 'Drawer',
  name: 'DrawerContent',
})<{ padding?: boolean }>`
  padding: 1rem ${(props) => (props.padding === false ? 0 : '1.5rem')};
`;
